import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { AboutService, AlertService } from "../_services";
import { Router } from "@angular/router";
import { FormBuilder, Validators } from "@angular/forms";
import { TempMailService } from "../_services/tempmail.service";
import {
  ImageSettingsModel,
  RichTextEditorComponent,
  ToolbarSettingsModel,
} from "@syncfusion/ej2-angular-richtexteditor";
declare var RichTextEditor: any;

@Component({
  selector: "app-temp-email",
  templateUrl: "./temp-email.component.html",
})
export class TempEmailComponent implements OnInit {
  @ViewChild("rteInstance", { static: true })
  rteInstance: RichTextEditorComponent; // Fixed ViewChild

  public imageSettings: ImageSettingsModel = {
    saveFormat: "Base64",
    allowedTypes: [".jpg", ".png", ".gif"],
    saveUrl: null,
  };

  public toolbarSettings: ToolbarSettingsModel = {
    items: [
      "Bold",
      "Italic",
      "Underline",
      "StrikeThrough",
      "FontName",
      "FontSize",
      "FontColor",
      "BackgroundColor",
      "LowerCase",
      "UpperCase",
      "|",
      "Formats",
      "Alignments",
      "OrderedList",
      "UnorderedList",
      "Outdent",
      "Indent",
      "|",
      "CreateLink",
      "Image",
      "CreateTable",
      "|",
      "ClearFormat",
      "Print",
      "SourceCode",
      "FullScreen",
      "|",
      "Undo",
      "Redo",
      {
        tooltipText: "Insert Variable",
        template: `<select id="variablesDropdown" style="padding: 5px; border-radius: 4px;">
                    <option value="">Insert Variable</option>
                    <option value="{{firstName}}">First Name</option>
                    <option value="{{lastName}}">Last Name</option>
                    <option value="{{email}}">Email</option>
                    <option value="{{company}}">Company</option>
                  </select>`,
      },
    ],
  };

  showloding = false;
  lodingImage = false;
  TempMailForm: any;
  isSubmitted = false;
  value: string = "";

  variables: { label: string; value: string }[] = [
    { label: "First Name", value: "{{firstName}}" },
    { label: "Last Name", value: "{{lastName}}" },
    { label: "Email", value: "{{email}}" },
    { label: "Company", value: "{{company}}" },
  ];

  constructor(
    public router: Router,
    private service: TempMailService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.TempMailForm = this.fb.group({
      to: ["", [Validators.required, Validators.email]],
      subject: ["", Validators.required],
      body: [""],
    });
    window.scroll(0, 0);
    this.loadHide();
  }

  ngAfterViewInit() {
    const dropdown = document.getElementById(
      "variablesDropdown"
    ) as HTMLSelectElement;
    if (dropdown) {
      dropdown.addEventListener("change", (event: Event) => {
        const variable = (event.target as HTMLSelectElement).value;
        if (variable) {
          this.insertVariableAtCursor(variable);
          (event.target as HTMLSelectElement).value = "";
        }
      });
    }
  }

  insertVariableAtCursor(variable: string) {
    if (this.rteInstance) {
      this.rteInstance.executeCommand("insertText", variable);
      this.value = this.rteInstance.getHtml();
      this.TempMailForm.patchValue({ body: this.value });
    }
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.TempMailForm.get(fieldName);
    return !!(field && field.invalid && (field.touched || this.isSubmitted));
  }

  onSubmit() {
    this.TempMailForm.patchValue({ body: this.value });
    this.isSubmitted = true;

    if (this.TempMailForm.valid && this.value.trim() !== "") {
      this.loadShow();

      const formData: FormData = new FormData();
      formData.append("subject", this.TempMailForm.value.subject);
      formData.append("html", this.TempMailForm.value.body);
      formData.append("emails", this.TempMailForm.value.to);

      this.service.save(formData).subscribe({
        next: (res: any) => {
          if (res["status"] === 200) {
            this.loadHide();
            this.TempMailForm.reset();
            this.value = "";
            this.isSubmitted = false;
            if (this.rteInstance) {
              this.rteInstance.value = "";
            }
          } else {
            this.loadHide();
          }
        },
        error: (err) => {
          console.error(err);
          this.loadHide();
        },
      });
    } else {
      console.log("Form is invalid");
    }
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }
}
